module.exports = __webpack_public_path__ + "static/media/Water-motor.31b09a41.jpg";